import './radioButton.scss';
import type {RadioButton_Listing_Step_Props} from "./RadioButton.interface";
import {Paragraph} from "../../Elements/Paragraph";
import {useTranslation} from "react-i18next";

/**
 * Primary UI component for user interaction
 */
export function ListingStepRadioButton (props:RadioButton_Listing_Step_Props) {

    const {t} = useTranslation();

    const getLeadingWord = (index: number) => {
        return t('button.radio.listingStep.step') + index + ": ";
    };
    
    return (
        <div className={["radiobutton-wrapper", props.className, props.hide ? "hide" : "", props.recommended ? "highlight" : "no-highlight"].join(" ")}>
            {props.recommended &&
            <div className={"recommended"} onClick={props.onClick}>
                {t("button.recommended")}
            </div>
            }
            <div className="radiobutton-input-row" onClick={props.onClick}>
                <div className="input">
                    <input id={props.id} aria-label={props.id} readOnly type="radio" checked={props.selected}/>
                </div>
                <div>
                    <label htmlFor={props.id} aria-label={props.id}>
                        {props.label}
                    </label>
                </div>
            </div>
            {props.selected &&
                <div className="radiobutton-content-row listing">
                    {props.steps.map((str, index) => {
                        return (<div key={index} className="step">
                            <strong><Paragraph text={getLeadingWord(index)}/></strong>
                            <Paragraph text={str}/>
                        </div>);
                    })}
                </div>
            }
        </div>
    );
}
